// packages/storefront/src/components/general/useCurrentUrlCopy.ts
//
// The copy-to-clipboard of the page's address that `CurrentUrlCopyBox` (MUI) and the terms widget's own copy of it
// (no MUI) both offer. No MUI here.
import { useState } from 'react';

/** How long the button says "Copied" after a copy. */
const COPIED_MS = 2000;

/** The page's address, whether it was just copied, and the copy. */
export function useCurrentUrlCopy(): { url: string; copied: boolean; copy: () => void } {
	const [copied, setCopied] = useState(false);
	const url = window.location.href;
	const copy = () => {
		void (async () => {
			try {
				await navigator.clipboard.writeText(url);
				setCopied(true);
				setTimeout(() => {
					setCopied(false);
				}, COPIED_MS);
			} catch {
				// Clipboard write can fail on insecure origins / older browsers;
				// the URL is still visible on screen for manual copy.
			}
		})();
	};
	return { url, copied, copy };
}
